export default "__VITE_ASSET__7f3fda07__"